
/* LilaZen - Fix Product Description Jump */
/* Minimog OS 2.0 5.9.0 */

(function () {
  function fixProductInfoSticky() {
    const button = [...document.querySelectorAll('button')]
      .find(el => el.textContent.trim() === 'Product description');

    if (!button) return;

    let node = button;

    while (node && node !== document.body) {
      if (getComputedStyle(node).position === 'sticky') {
        node.style.setProperty('position', 'static', 'important');
      }

      node = node.parentElement;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductInfoSticky);
  } else {
    fixProductInfoSticky();
  }

  document.addEventListener('shopify:section:load', fixProductInfoSticky);
})();
